export default class MenuTrigger {
  constructor() {
		this.DOM = {}
		this.DOM.html      = document.getElementsByTagName( 'html' )[0]
		this.DOM.trigger   = document.getElementById( 'js-menu-trigger' )
		this.DOM.btnDotted = this.DOM.trigger.querySelector( '.c-menu-btn_dotted' )
		this.DOM.btnLine   = this.DOM.trigger.querySelector( '.c-menu-btn_line' )

		this.eventType = this._getEventType()
		this.handleEvent()
  }

	_getEventType() {
		return window.ontouchstart ? 'touchstart' : 'click'
	}

  handleEvent() {
		if ( !this.DOM.trigger ) { return }

		this.DOM.trigger.addEventListener( this.eventType, e => {
			e.stopPropagation()
			this.DOM.html.classList.toggle( 'menu-open' )
			this.DOM.btnDotted.classList.toggle( 'is-hidden' )
			this.DOM.btnLine.classList.toggle( 'is-visible' )
  	})
  }

}

